/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Date_WarningInputs */

const en_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide a start and end date for custom queries.`)
};

const fr_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez fournir une date de début et de fin pour les requêtes personnalisées.`)
};

const de_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie für individuelle Anfragen ein Start- und Enddatum an.`)
};

const it_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per le query personalizzate, specificare una data di inizio e di fine.`)
};

const ru_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, укажите начальную и конечную даты для пользовательских запросов.`)
};

const es_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporcione una fecha de inicio y finalización para consultas personalizadas.`)
};

const zh_cn2_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请为自定义查询提供开始日期和结束日期。`)
};

const ja_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムクエリの開始日と終了日を指定してください。`)
};

const hi_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया कस्टम क्वेरी के लिए प्रारंभ और समाप्ति तिथि प्रदान करें।`)
};

const pt_pt2_custom_date_warning = /** @type {(inputs: Custom_Date_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, indique uma data de início e uma data de término para consultas personalizadas.`)
};

/**
* | output |
* | --- |
* | "Please provide a start and end date for custom queries." |
*
* @param {Custom_Date_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_date_warning = /** @type {((inputs?: Custom_Date_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Date_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_custom_date_warning(inputs)
	if (locale === "de") return de_custom_date_warning(inputs)
	if (locale === "it") return it_custom_date_warning(inputs)
	if (locale === "ru") return ru_custom_date_warning(inputs)
	if (locale === "es") return es_custom_date_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_custom_date_warning(inputs)
	if (locale === "ja") return ja_custom_date_warning(inputs)
	if (locale === "hi") return hi_custom_date_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_custom_date_warning(inputs)
	return en_custom_date_warning(inputs)
});